<ng-container *ngIf="editableChatBotIndex === null; else chatBotSettings">
    <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

    <div class="panel-options-body overflow-wrapper">
        <form class="form form-horizontal" (submit)="$event.preventDefault()">
            <div class="form-row">
                <div class="form-group mb-20">
                    <div
                        class="col-xs-12"
                        cdkDropList
                        [cdkDropListData]="chatBots"
                        (cdkDropListDropped)="dropElementItem($event)"
                    >
                        <div
                            *ngFor="let chatBot of chatBots.getRawValue(); let i = index"
                            cdkDrag
                            cdkDropListGroup
                            [cdkDragData]="chatBot"
                        >
                            <sp-control-handle
                                [controlHandleBtn]="chatBots.length === 1 ? false : true"
                                [controlHandleDisableDelete]="chatBots.length === 1"
                                [controlHandleIcon]="getSocialNetworkIconSrcByChatBot(chatBot)"
                                [controlHandleMainText]="chatBot.name"
                                [controlHandleSubText]="getChatBotSubText(chatBot)"
                                [controlHandleSubTextWarning]="!chatBot.link"
                                (editActionEvent)="editChatBot(i)"
                                (removeActionEvent)="removeSocial(i)"
                            ></sp-control-handle>
                        </div>
                        <a class="dotted" (click)="addChatBot()">{{ "add" | translate }}</a>
                    </div>
                </div>

                <div class="form-group mb-10">
                    <label class="col-xs-12">
                        {{ "control_appearance" | translate }}
                    </label>
                    <div class="col-xs-12">
                        <div class="btn-group d-flex">
                            <div
                                class="btn btn-grey w-100"
                                [class.active]="type.value === EButtonType.icon"
                                (click)="onSwitchButtonType(EButtonType.icon)"
                            >
                                {{ "control_appearance_icon" | translate }}
                            </div>
                            <div
                                class="btn btn-grey w-100"
                                [class.active]="type.value === EButtonType.button"
                                (click)="onSwitchButtonType(EButtonType.button)"
                            >
                                {{ "control_appearance_button" | translate }}
                            </div>
                        </div>
                    </div>
                </div>

                <!--показываем если выбран внешний вид "Кнопка"-->
                <ng-container *ngIf="!isIcon">
                    <div class="form-group mb-20">
                        <label class="col-xs-12">
                            {{ "control_button_style" | translate }}
                        </label>
                        <div class="col-xs-6">
                            <select class="form-control" [formControl]="styleType">
                                <option [ngValue]="EButtonStyleType.primary">
                                    {{ "control_appearance_primary" | translate }}
                                </option>
                                <option [ngValue]="EButtonStyleType.secondary">
                                    {{ "control_appearance_secondary" | translate }}
                                </option>
                                <option [ngValue]="EButtonStyleType.custom">
                                    {{ "control_appearance_custom" | translate }}
                                </option>
                            </select>
                        </div>
                        <div class="col-xs-6">
                            <sp-radio-group
                                [selected]="buttonSize.value"
                                [type]="ERadioGroupType.size"
                                (changeSelectedEvent)="setButtonSize($event)"
                            ></sp-radio-group>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="styleType.value === EButtonStyleType.custom && !isIcon">
                    <div class="mb-20">
                        <web-custom-button
                            [parentBase]="buttonBase.value"
                            [parentHover]="buttonHover.value"
                            [isIndependentCorners]="isIndependentCorners.value"
                            [radiusSettings]="advancedRadius.value"
                            [advancedBorderSettings]="advancedBorderSettings.value"
                            [isAdvancedRadius]="true"
                            (valueChangeEvent)="customButtonChangeHandler($event)"
                        ></web-custom-button>
                    </div>
                </ng-container>

                <ng-container *ngIf="!isIcon">
                    <div class="form-group" [class.mb-20]="!isShadow.value" [class.mb-10]="isShadow.value">
                        <label class="col-xs-9 control-label">
                            {{ "control_shadow" | translate }}
                        </label>
                        <div class="col-xs-3 text-right">
                            <sp-switch [active]="isShadow.value" (toggleActiveEvent)="setShadow($event)"></sp-switch>
                        </div>
                    </div>

                    <ng-container *ngIf="isShadow.value">
                        <sp-shadow-settings
                            [shadowSettings]="shadowSettingsValue"
                            (valueChangeEvent)="setShadowSettings($event)"
                        ></sp-shadow-settings>
                    </ng-container>
                </ng-container>

                <!--показываем если выбран внешний вид "Іконка"-->
                <div *ngIf="isIcon" class="form-group mb-10">
                    <div class="col-xs-12">
                        <web-social-networks
                            [iconType]="iconType.value"
                            [iconNames]="getMessengerNames()"
                            [iconTypes]="ICON_TYPES"
                            (iconTypeChangeEvent)="setIconType($event)"
                        ></web-social-networks>
                    </div>
                </div>

                <!--показываем если выбран внешний вид "Иконка"-->
                <div *ngIf="isIcon" class="form-group mb-20">
                    <label class="col-xs-7 control-label">
                        {{ "control_size" | translate }}
                    </label>
                    <div class="col-xs-5">
                        <sp-input-num
                            suffixText="px"
                            [max]="ICON_SIZE_MAX"
                            [value]="height.value"
                            (valueChange)="setHeight($event)"
                        ></sp-input-num>
                    </div>
                </div>

                <ng-container *ngIf="!isSpecific">
                    <div class="form-group mb-10">
                        <div class="col-xs-12 device-toggle-wrapper">
                            <web-device-toggle></web-device-toggle>

                            <web-synchronize-style-toggle
                                [active]="isSynchronizeStyle.value"
                                (click)="setSynchronizeStyle()"
                            ></web-synchronize-style-toggle>
                        </div>
                    </div>

                    <ng-container *ngIf="isDeviceDesktop$ | async">
                        <div class="form-group mb-0">
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "desktop_device_hint" | translate }}
                            </p>
                        </div>

                        <ng-container *ngTemplateOutlet="desktopSettings"> </ng-container>
                    </ng-container>

                    <ng-container *ngIf="isDeviceTablet$ | async">
                        <div class="form-group mb-0">
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "tablet_device_hint" | translate }}
                            </p>
                        </div>

                        <ng-container *ngIf="isSynchronizeStyle.value; then desktopSettings; else tabletSettings">
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="isDeviceMobile$ | async">
                        <div class="form-group mb-0">
                            <p class="col-xs-12 help-block text-muted small">
                                {{ "mobile_device_hint" | translate }}
                            </p>
                        </div>

                        <ng-container *ngIf="isSynchronizeStyle.value; then desktopSettings; else mobileSettings">
                        </ng-container>
                    </ng-container>

                    <ng-template #desktopSettings>
                        <div class="form-group mb-20">
                            <label class="col-xs-7 control-label">
                                {{ "control_content_alignment" | translate }}
                            </label>
                            <div class="col-xs-5">
                                <sp-radio-group
                                    [selected]="horizontalAlign.value"
                                    [type]="ERadioGroupType.horizontalPosition"
                                    (changeSelectedEvent)="setHorizontalAlign($event)"
                                ></sp-radio-group>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #tabletSettings>
                        <div class="form-group mb-20">
                            <label class="col-xs-7 control-label">
                                {{ "control_content_alignment" | translate }}
                            </label>
                            <div class="col-xs-5">
                                <sp-radio-group
                                    [selected]="tabletHorizontalAlign.value"
                                    [type]="ERadioGroupType.horizontalPosition"
                                    (changeSelectedEvent)="setTabletHorizontalAlign($event)"
                                ></sp-radio-group>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #mobileSettings>
                        <div class="form-group mb-20">
                            <label class="col-xs-7 control-label">
                                {{ "control_content_alignment" | translate }}
                            </label>
                            <div class="col-xs-5">
                                <sp-radio-group
                                    [selected]="mobileHorizontalAlign.value"
                                    [type]="ERadioGroupType.horizontalPosition"
                                    (changeSelectedEvent)="setMobileHorizontalAlign($event)"
                                ></sp-radio-group>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </div>

            <div class="mt-20">
                <web-widget-position-settings
                    [isSynchronized]="isSynchronizeStyle.value"
                    [isTablet]="isDeviceTablet$ | async"
                    [isMobile]="isDeviceMobile$ | async"
                    [widgetId]="widget.id"
                    [columnId]="widget.columnId"
                    [position]="position.value"
                    (positionChange)="position.patchValue($event)"
                ></web-widget-position-settings>

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>

                <web-widget-extended-hide-settings
                    [hideOnDesktop]="hideOnDesktop.value"
                    [hideOnTablet]="hideOnTablet.value"
                    [hideOnMobile]="hideOnMobile.value"
                    (hideOnDesktopChange)="hideOnDesktop.setValue($event)"
                    (hideOnTabletChange)="hideOnTablet.setValue($event)"
                    (hideOnMobileChange)="hideOnMobile.setValue($event)"
                ></web-widget-extended-hide-settings>

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>
            </div>

            <div class="mt-20">
                <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                </web-custom-id>
            </div>
        </form>
    </div>
</ng-container>
<ng-template #chatBotSettings>
    <web-chat-bot-settings
        [itemForm]="editingChatBot"
        [chatBotsList]="chatBots$(editingChatBot.value.socialNetwork) | async"
        (cancelEvent)="editChatBot(null)"
    ></web-chat-bot-settings>
</ng-template>
